import api from '@/apis'
import router from '@/router'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    submit_btn_disable: false,
    visibility: false,
    type: null,
    item: null
  },
  mutations: {
    INIT_DELETE_ITEM_DIALOG(state, payload) {
      state.visibility = true
      state.type = payload.type
      state.item = payload.item
    },
    SET_DELETE_ITEM_DIALOG_SUBMIT_BTN_DISABLE(state, payload) {
      state.submit_btn_disable = payload
    },
    RESET_DELETE_ITEM_DIALOG(state) {
      state.visibility = false
      setTimeout(() => {
        state.type = null
        state.item = null
      }, 100)
    }
  },
  actions: {
    async deleteItem({ state, commit, dispatch, rootState }) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.deleting', ''), loading: true })
        commit('SET_DELETE_ITEM_DIALOG_SUBMIT_BTN_DISABLE', true)

        let response = null
        if (state.type === 'keyword') response = await api.deleteEntity({ params: { entity_id: state.item.entity_id } })
        else if (state.type === 'unit') response = await api.deleteUnit({ params: { id: state.item.id } })
        else if (state.type === 'category') response = await api.deleteCategory({ params: { id: state.item.id } })
        else if (state.type === 'question') response = await api.deleteQuestionTopic({ params: { id: state.item.id } })
        else if (state.type === 'response') response = await api.deleteResponse({ params: { id: state.item.id } })
        else if (state.type === 'user') response = await api.deleteUser({ params: { device_id: rootState.auth.selected_device, user_id: state.item.user_id } })
        else if (state.type === 'mrc') response = await api.deleteMrcDoc({ params: { id: state.item.id } })
        else if (state.type === 'avatar') response = await api.deleteVideoAvatar({ params: { device_id: rootState.auth.selected_device, avatar_id: state.item.id } })
        else if (state.type === 'event') response = await api.deleteEvent({ params: { device_id: rootState.auth.selected_device }, event_id: state.item.id })
        // else if (state.type === 'idle_video') response = await api.updateIdleScreen({ params: { device_id: rootState.auth.selected_device, video: { selected_video_id: null } } })
        else if (state.type === 'idle_video') response = await api.deleteIdleScreen({ params: { device_id: rootState.auth.selected_device, video_id: state.item } })
        else if (state.type === 'quiz') response = await api.deleteQuiz({ params: { device_id: rootState.auth.selected_device }, quiz_id: state.item.quiz_id })
        else if (state.type === 'quiz_question')
          response = await api.deleteQuestion({ params: { device_id: rootState.auth.selected_device }, quiz_id: state.item.quiz_id, question_id: state.item.question_id })
        else if (state.type === 'location') response = await api.deleteLocation({ location_id: state.item.id, params: { device_id: rootState.auth.selected_device } })
        else if (state.type === 'category_layer') response = await api.deleteCategoryLayer({ category_id: state.item.topic.category_id, params: { device_id: rootState.auth.selected_device } })

        if (response.data.success) {
          if (state.type === 'keyword') dispatch('fetchEntityList')
          else if (state.type === 'unit') dispatch('fetchDirectory')
          else if (state.type === 'category') dispatch('fetchCategoryList')
          else if (state.type === 'question') {
            dispatch('fetchQuestionTopicList')
            if (router.currentRoute.path !== '/ai/keyword' && state.item.from === 'question_topic') router.push({ path: '/ai/keyword' })
            else if (state.item.from === 'breadcrumb') window.location.reload()
            else if (state.item.from === 'finder') dispatch('fetchTopicDataFinder')
          } else if (state.type === 'response') dispatch('fetchQuestionTopicKeywordAndResponse', { intent_id: state.item.intent_id })
          else if (state.type === 'user') dispatch('fetchUserList')
          else if (state.type === 'mrc') dispatch('fetchMrcAiScanList', state.item.params)
          else if (state.type === 'avatar') dispatch('fetchVirtualAvatarList')
          else if (state.type === 'event') dispatch('fetchEventLibrary')
          else if (state.type === 'idle_video') dispatch('fetchIdleScreenMedia', 'video')
          else if (state.type === 'quiz') {
            dispatch('fetchQuizLibrary')
            commit('SET_QUIZ_LIBRARY_DIALOG_SELECTED_QUIZ_ID', null)
          } else if (state.type === 'quiz_question') dispatch('fetchQuizDetail', state.item.quiz_id)
          else if (state.type === 'location') dispatch('fetchLocationList')
          else if (state.type === 'category_layer')
            commit('DELETE_CATEGORY_COLUMN_TOPIC_LAYER', {
              index: state.item.layer_i,
              topic_index: state.item.topic_i,
              parent_id: state.item.topic_layer.parent_id,
              category_id: state.item.topic.category_id
            })

          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.delete', ''), icon: 'check', timeout: '2000' })
          commit('RESET_DELETE_ITEM_DIALOG')
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_DELETE_ITEM_DIALOG_SUBMIT_BTN_DISABLE', false)
      }
    }
  }
}
